import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a806966bedae70014908cd3_1788343011605_b342072a/privateluxuryworld/src/app/sign-up-login-screen/components/AuthSurface.tsx");
